import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcEvernorthDefault,
} from '@cigna/chcp/shared/environment-util';

const digitaledgeEpp = 'https://p-evernorth-provider.digitaledge.cigna.com';
const resourceLibraryCdn = 'https://static.evernorth.com/';

export const environment: EnvironmentConfig = {
  ...environmentDefaults('evernorth-provider-web'),
  authMethod: 'auth0',
  oidc: {
    ...oidcEvernorthDefault,
    secureUris: [],
  },
  auth0: {
    audience: digitaledgeEpp,
    clientId: 'JMYdjCuoIBLtapgAct8gcfFPIdPQTEss',
    connection: 'providers-prod',
    domain: 'https://p.universal-login.cigna.com',
    scope: 'openid profile email',
    redirect_uri: 'https://provider.evernorth.com',
    secureUris: [digitaledgeEpp, '/pbc', `${resourceLibraryCdn}secure/`],
    impersonationConnection: 'workforce',
    impersonationReturnTo: '/dashboard',
    cookieStorage: true,
  },
  redirect: {
    resourceLibrary: resourceLibraryCdn,
    resourceLibraryDrupal: '',
    crossOrigin: {
      domain: 'https://cignaforhcp.cigna.com',
    },
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: '',
      resourceContent: 'https://p-digital-static.digitaledge.cigna.com/',
      secureApi: digitaledgeEpp,
      publicApi: `https://p-public.digitaledge.evernorth.com/public`,
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
      graphql: `${digitaledgeEpp}/apollo-graphql`,
      privateLinkRouter: `https://p-evernorth-provider.digitaledge.cigna.com/pbc/identity/v1/federate/_route`,
      publicLinkRouter: '', // todo: update
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhPower: false,
    claim360GA: false,
    enablePCM: false,
    hasCBHAmIInNetwork: false,
    cocePathwellPCLM: false,
  },
  launchDarklyClientId: '6627eacd49bac51024871748',
  disabledRoutes: [],
};
